<template>
  <section
    ref="containerRef"
    class="ScrollAwareContainer"
  >
    <slot />
  </section>
</template>

<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref, useTemplateRef } from "vue";

const {
  size = 24,
} = defineProps<{
  size?: number,
}>();

const overflowTop = ref(0);
const overflowBottom = ref(0);
const resizeObserver = new ResizeObserver(handleResize);

const containerRef = useTemplateRef("containerRef");

onMounted(() => {
  if (containerRef.value) {
    containerRef.value.addEventListener("scroll", handleScroll);
    resizeObserver.observe(containerRef.value);
    handleScroll();
  }
});

onBeforeUnmount(() => {
  if (containerRef.value) {
    resizeObserver.unobserve(containerRef.value);
    containerRef.value.removeEventListener("scroll", handleScroll);
  }
});

function updateScroll () {
  if (!containerRef.value) return;

  const {
    scrollTop,
    scrollHeight,
    offsetHeight,
  } = containerRef.value;

  overflowTop.value = Math.min(size, scrollTop);
  overflowBottom.value = Math.min(size, (scrollHeight - offsetHeight) - Math.round(scrollTop));
}

function handleScroll () {
  updateScroll();
}

function handleResize () {
  updateScroll();
}
</script>

<style lang="scss" scoped>
.ScrollAwareContainer {
  overflow-y: auto;
  mask: linear-gradient(
    to bottom,
    transparent 0,
    black calc(1px * v-bind(overflowTop)),
    black calc(100% - 1px * v-bind(overflowBottom)),
    transparent 100%,
  );
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
